import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MultiLanguageModule } from '@/app/multi-language.module';
import { AppUpdateService } from './app-update.service';

/**
 * Navbar-chip zolang er een nieuwe versie klaarstaat die de gebruiker (nog) niet laadde,
 * bv. na "later" in de dialoog. Klikken toont de dialoog opnieuw.
 */
@Component({
  selector: 'egi-app-update-indicator',
  imports: [MultiLanguageModule],
  templateUrl: './app-update-indicator.component.html',
  styleUrl: './app-update-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppUpdateIndicatorComponent {
  protected readonly update = inject(AppUpdateService);

  protected readonly visible = computed(() => this.update.available() && !this.update.dialogOpen());
}
